import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { authAPI } from '../services/api';

const AuthGuard = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const verifyAuth = async () => {
      if (!loading && !isAuthenticated) {
        // If no token, redirect to login
        navigate('/login', { replace: true });
        return;
      }

      if (user?.token) {
        try {
          // Verify token with server
          const response = await authAPI.verify();
          if (response.status !== 200) {
            // Token is invalid, redirect to login
            navigate('/login', { replace: true });
          }
        } catch (error) {
          // Token verification failed, redirect to login
          navigate('/login', { replace: true });
        }
      }
    };

    verifyAuth();
  }, [isAuthenticated, loading, user, navigate]);

  // Show loading while checking authentication
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: '#ffffff'
      }}>
        <div style={{
          width: '50px',
          height: '50px',
          border: '4px solid rgba(197, 51, 123, 0.3)',
          borderTop: '4px solid #C5337B',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} />
      </div>
    );
  }

  // Only render children if authenticated
  if (!isAuthenticated) {
    return null;
  }

  return children;
};

export default AuthGuard;
